import { API_CALL } from '../../../middleware/api';

export const GET_CLINICIAN_ROSTER_CONFIGURATION = 'GET_CLINICIAN_ROSTER_CONFIGURATION';
export const GET_CLINICIAN_ROSTER_CONFIGURATION_RESULT = `${GET_CLINICIAN_ROSTER_CONFIGURATION}/result`;
export const CREATE_CLINICIAN_ROSTER_RELEASE = 'CREATE_CLINICIAN_ROSTER_RELEASE';
export const CREATE_CLINICIAN_ROSTER_RELEASE_RESULT = `${CREATE_CLINICIAN_ROSTER_RELEASE}/result`;
export const PUBLISH_CLINICIAN_ROSTER_RELEASE = 'PUBLISH_CLINICIAN_ROSTER_RELEASE';
export const PUBLISH_CLINICIAN_ROSTER_RELEASE_RESULT = `${PUBLISH_CLINICIAN_ROSTER_RELEASE}/result`;

export const actions = {
  getConfiguration: organizationId => ({
    [API_CALL]: { method: 'GET', endpoint: `portal/v1/superadmin/cmmi-access/clinician-roster/${organizationId}` },
    type: GET_CLINICIAN_ROSTER_CONFIGURATION,
  }),
  createRelease: (organizationId, release) => ({
    [API_CALL]: { method: 'POST', endpoint: `portal/v1/superadmin/cmmi-access/clinician-roster/${organizationId}/releases`, data: release },
    type: CREATE_CLINICIAN_ROSTER_RELEASE,
  }),
  publishRelease: releaseId => ({
    [API_CALL]: { method: 'POST', endpoint: `portal/v1/superadmin/cmmi-access/clinician-roster-releases/${releaseId}/publish` },
    type: PUBLISH_CLINICIAN_ROSTER_RELEASE,
  }),
};
